/**
 * - A lightweight _STEP ONE CHECK_ for cancellations journey access.
 * - It is specifically driven by posthog and policy details
 * - Full journey access should be further supported by separate eligibility checks via the cancellation API.
 *
 * IMPORTANT -
 * - DO NOT bloat this function with product based logic - `isTaxi` etc. - this is handled in the eligibility checks ([backend driven](https://dev.azure.com/IT-Developers-UK/TGG/_git/Core_Cancellation_Api?path=/src/Api.Core.Cancellation/WebAPI/Controllers/CancellationController.cs&version=GBdevelop&_a=contents)), which are outside of this function scope.
 * - The one exception to this is the `isActive` check. The BE also does this check in later API calls, but this is an edge case UX consideration for faster show/hide behaviour.
 *
 * @param featureFlag - Indicates if the feature is enabled in posthog (a temporary blocker/enabler)
 * @param isActive - Indicates if the policy is active
 * @param policyToken - The policy token - essential for eligibility API calls
 * @param policyNumber - The policy number - essential for mid journey API calls
 * @returns True if this _step one_ check passes, false otherwise.
 */
export const checkCancellationPreRequisites = (
	featureFlag: boolean, // to remove post-release
	isActive: boolean,
	policyNumber: string | undefined,
	policyToken: string | undefined,
) => {
	if (!featureFlag || !isActive || !policyNumber || !policyToken) {
		return false;
	}
	return true;
};
